module.exports = __webpack_public_path__ + "img/skh3.0ec58ff7.jpg";